import { createTheme } from "@material-ui/core/styles";
import createBreakpoints from "@material-ui/core/styles/createBreakpoints";

function pxToRem(value) {
  return `${value / 16}rem`;
}

const breakpoints = createBreakpoints({});
const theme = createTheme({
  breakpoints,

  palette: {
    primary: {
      main: "#FF0083",
    },
    secondary: {
      main: "#FD2B88",
    },
    error: {
      main: "#FF0040",
    },
    background: {
      default: "#09092D",
    },
  },
  typography: {
    fontFamily: "Manrope",
    h1: {
      [breakpoints.down("xl")]: {
        fontSize: pxToRem(34),
      },
      [breakpoints.down("lg")]: {
        fontSize: pxToRem(34),
      },
      [breakpoints.down("md")]: {
        fontSize: pxToRem(28),
      },
      [breakpoints.down("sm")]: {
        fontSize: pxToRem(24),
      },
      [breakpoints.down("xs")]: {
        fontSize: pxToRem(20),
      },
      lineHeight: 50 / 34,
      fontWeight: 600,
    },
    h2: {
      //fontSize: 30,
      [breakpoints.down("xl")]: {
        fontSize: pxToRem(30),
      },
      [breakpoints.down("lg")]: {
        fontSize: pxToRem(30),
      },
      [breakpoints.down("md")]: {
        fontSize: pxToRem(26),
      },
      [breakpoints.down("sm")]: {
        fontSize: pxToRem(22),
      },
      [breakpoints.down("xs")]: {
        fontSize: pxToRem(18),
      },
      lineHeight: 41 / 30,
      fontWeight: 600,
    },
    h3: {
      // fontSize: 26,
      [breakpoints.down("xl")]: {
        fontSize: pxToRem(26),
      },
      [breakpoints.down("lg")]: {
        fontSize: pxToRem(26),
      },
      [breakpoints.down("md")]: {
        fontSize: pxToRem(24),
      },
      [breakpoints.down("sm")]: {
        fontSize: pxToRem(20),
      },
      [breakpoints.down("xs")]: {
        fontSize: pxToRem(16),
      },
      lineHeight: 34 / 26,
      fontWeight: 400,
    },
    h4: {
      //fontSize: 24,
      [breakpoints.down("xl")]: {
        fontSize: pxToRem(24),
      },
      [breakpoints.down("lg")]: {
        fontSize: pxToRem(24),
      },
      [breakpoints.down("md")]: {
        fontSize: pxToRem(20),
      },
      [breakpoints.down("sm")]: {
        fontSize: pxToRem(16),
      },
      [breakpoints.down("xs")]: {
        fontSize: pxToRem(12),
      },
      lineHeight: 33 / 24,
      fontWeight: 700,
    },
    h5: {
      //fontSize: 18,
      [breakpoints.down("xl")]: {
        fontSize: pxToRem(18),
      },
      [breakpoints.down("lg")]: {
        fontSize: pxToRem(18),
      },
      [breakpoints.down("md")]: {
        fontSize: pxToRem(14),
      },
      [breakpoints.down("sm")]: {
        fontSize: pxToRem(10),
      },
      [breakpoints.down("xs")]: {
        fontSize: pxToRem(8),
      },
      lineHeight: 24 / 18,
      fontWeight: 600,
    },
    h6: {
      //fontSize: 20,
      [breakpoints.down("xl")]: {
        fontSize: pxToRem(20),
      },
      [breakpoints.down("lg")]: {
        fontSize: pxToRem(20),
      },
      [breakpoints.down("md")]: {
        fontSize: pxToRem(16),
      },
      [breakpoints.down("sm")]: {
        fontSize: pxToRem(12),
      },
      [breakpoints.down("xs")]: {
        fontSize: pxToRem(8),
      },
      lineHeight: 27 / 20,
      fontWeight: 400,
    },
    p1: {
      // fontSize: 15,
      [breakpoints.down("xl")]: {
        fontSize: pxToRem(15),
      },
      [breakpoints.down("lg")]: {
        fontSize: pxToRem(15),
      },
      [breakpoints.down("md")]: {
        fontSize: pxToRem(11),
      },
      [breakpoints.down("sm")]: {
        fontSize: pxToRem(8),
      },
      [breakpoints.down("xs")]: {
        fontSize: pxToRem(8),
      },
      lineHeight: 26 / 15,
      fontWeight: 400,
    },
    p2: {
      //fontSize: 14,
      [breakpoints.down("xl")]: {
        fontSize: pxToRem(14),
      },
      [breakpoints.down("lg")]: {
        fontSize: pxToRem(14),
      },
      [breakpoints.down("md")]: {
        fontSize: pxToRem(10),
      },
      [breakpoints.down("sm")]: {
        fontSize: pxToRem(8),
      },
      lineHeight: 22 / 14,
      fontWeight: 400,
    },
    button: {
      //fontSize: 13,
      [breakpoints.down("xl")]: {
        fontSize: pxToRem(13),
      },
      [breakpoints.down("lg")]: {
        fontSize: pxToRem(13),
      },
      [breakpoints.down("md")]: {
        fontSize: pxToRem(12),
      },
      [breakpoints.down("sm")]: {
        fontSize: pxToRem(10),
      },
      [breakpoints.down("xs")]: {
        fontSize: pxToRem(8),
      },
      lineHeight: 18 / 12,
      letterSpacing: 0.2,
      fontWeight: 700,
      textTransform: "unset",
    },
    c1: {
      //fontSize: 13,
      [breakpoints.down("xl")]: {
        fontSize: pxToRem(13),
      },
      [breakpoints.down("lg")]: {
        fontSize: pxToRem(13),
      },
      [breakpoints.down("md")]: {
        fontSize: pxToRem(10),
      },
      [breakpoints.down("sm")]: {
        fontSize: pxToRem(8),
      },
      lineHeight: 20 / 13,
      fontWeight: 500,
    },
    c2: {
      //fontSize: 12,
      [breakpoints.down("xl")]: {
        fontSize: pxToRem(12),
      },
      [breakpoints.down("lg")]: {
        fontSize: pxToRem(12),
      },
      [breakpoints.down("md")]: {
        fontSize: pxToRem(10),
      },
      [breakpoints.down("sm")]: {
        fontSize: pxToRem(8),
      },
      lineHeight: 17 / 12,
      fontWeight: 600,
    },
    label: {
      //fontSize: 11,
      [breakpoints.down("xl")]: {
        fontSize: pxToRem(11),
      },
      [breakpoints.down("lg")]: {
        fontSize: pxToRem(11),
      },
      [breakpoints.down("md")]: {
        fontSize: pxToRem(9),
      },
      [breakpoints.down("sm")]: {
        fontSize: pxToRem(7),
      },
      lineHeight: 15 / 11,
      fontWeight: 600,
    },
  },
 
  shadows: ["none", "none"],
  overrides: {},
});

export default theme;
